<template>
    <div
        class="grid h-full w-full grid-cols-[auto_min-content] items-stretch p-[0.2rem]"
        @click="clickable ? $emit('add') : null"
        @click.right.prevent="clickable ? $emit('subtract') : null"
    >
        <div class="font-title text-center font-black" :class="small ? 'text-md leading-5 lg:text-2xl lg:leading-8' : 'text-lg leading-8 lg:text-3xl lg:leading-12'">
            {{ dartsCount }}
        </div>
        <div
            class="font-title flex aspect-square h-full items-center justify-center rounded-md text-4xl font-bold p-2 lg:p-2.5 overflow-hidden"
            :class="{ 'opacity-40': (!isCurrentPlayersTurn && !clickable) || isSubmitting }"
            :style="{ backgroundColor: colorDark }"
        >
            <svg
                viewBox="0 0 14 14"
                class="h-full w-full"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                v-if="isCurrentPlayersTurn"
            >
                <path
                    d="M13.9648 7.94129V6.01913C13.9648 5.44873 13.4348 4.98633 12.781 4.98633L1.1836 4.98633C0.529779 4.98633 -0.000243187 5.44873 -0.000243187 6.01913V7.94129C-0.000243187 8.51169 0.529779 8.97409 1.1836 8.97409H12.781C13.4348 8.97409 13.9648 8.51169 13.9648 7.94129Z"
                    fill="white"
                />
                <path
                    d="M6.01993 13.957H7.94317C8.5139 13.957 8.97656 13.4273 8.97656 12.7738V1.18305C8.97656 0.529593 8.5139 -0.0001297 7.94317 -0.0001297H6.01993C5.4492 -0.0001297 4.98654 0.529593 4.98654 1.18305L4.98654 12.7738C4.98654 13.4273 5.4492 13.957 6.01993 13.957Z"
                    fill="white"
                />
            </svg>
            <svg
                viewBox="0 0 13 5"
                class="h-full w-full"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                v-else
            >
                <path
                    d="M12.709 3.0766V1.07532C12.709 0.481437 12.2267 0 11.6317 0L1.07806 0C0.483078 0 0.000757217 0.481437 0.000757217 1.07532V3.0766C0.000757217 3.67048 0.483078 4.15191 1.07806 4.15191L11.6317 4.15191C12.2267 4.15191 12.709 3.67048 12.709 3.0766Z"
                    fill="white"
                />
            </svg>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CamelStepInput',
    emits: ['add', 'subtract'],
    props: {
        // Number of clicks/darts queued for this camel this turn.
        dartsCount: {
            type: Number,
            default: 0,
        },
        // Whether it is this camel's turn (shows the plus icon, otherwise minus).
        isCurrentPlayersTurn: {
            type: Boolean,
            default: false,
        },
        // Whether this camel can currently be interacted with (affects dimming).
        clickable: {
            type: Boolean,
            default: false,
        },
        // Whether the score is currently being submitted (dims regardless of turn).
        isSubmitting: {
            type: Boolean,
            default: false,
        },
        // Dark camel colour (resolved hex string), used for the button background.
        colorDark: {
            type: String,
            required: true,
        },

        // Whether to use the smaller version of the component (used in the camel cards).
        small: {
            type: Boolean,
            default: false,
        },
    },
}
</script>
